import { BasicEvent } from "~app/features/planera/events/BasicEvent";

export class LeverantorsorderCreatedMessage extends BasicEvent {
    orderId?: number;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "LeverantorsorderCreatedMessage";
    constructor() {
        super(LeverantorsorderCreatedMessage.$type);
    }
}
